import { of as observableOf, Observable } from 'rxjs';

import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfigService } from '../../../services/config.service';
import { BusinessUnitService } from '../../../services/business-unit.service';
import { UserService } from '../../../services/user.service';
import {
  AssignmentBusinessUnitInfo,
  AssignBusinessUnitAdministrator,
} from '../../../models/identity';

@Component({
  selector: 'app-add-business-unit-administrator',
  templateUrl: './add-business-unit-administrator.component.html',
  styleUrls: ['./add-business-unit-administrator.component.scss'],
})
export class AddBusinessUnitAdministratorComponent implements OnInit {
  @Input() businessUnit: AssignmentBusinessUnitInfo;

  businessUnitAdministratorFilterOptions: Array<AssignBusinessUnitAdministrator> = [];
  selectedBusinessUnitAdministrators: Array<AssignBusinessUnitAdministrator> = [];
  modalRef: BsModalRef;
  selector: any;
  isAssingnmentInheritate: boolean = false;
  isOnSaving: boolean = false;

  constructor(
    private readonly bsModalService: BsModalService,
    private readonly configService: ConfigService,
    private readonly userService: UserService,
    private readonly businessUnitService: BusinessUnitService
  ) {}

  ngOnInit() {
    this.bsModalService.onHide.subscribe(() => {
      this.isOnSaving = false;
    });
  }

  public switchInheritation() {
    this.isAssingnmentInheritate = !this.isAssingnmentInheritate;
  }

  public openModal(template: TemplateRef<any>) {
    this.modalRef = this.bsModalService.show(template);
    this.businessUnitService
      .getAssignedToBusinessUnitBusinessUnitAdministrators(this.businessUnit.id)
      .subscribe((data) => {
        this.selectedBusinessUnitAdministrators = data;
      });
  }

  public assignBusinessUnitAdministrator(event: number) {
    if (!Number(event)) {
      return;
    }
    if (this.selectedBusinessUnitAdministrators.some((bu) => bu.id === event)) {
      return;
    }
    this.selectedBusinessUnitAdministrators.push(
      this.businessUnitAdministratorFilterOptions.find(
        (buAdmin) => buAdmin.id === event
      )
    );
  }

  public unAssignBusinessUnitAdministrator(event: number) {
    if (!Number(event)) {
      return;
    }
    this.selectedBusinessUnitAdministrators = this.selectedBusinessUnitAdministrators.filter(
      (buAdmin) => buAdmin.id !== event
    );
  }

  public searchBusinessUnitAdministratorByName(event: any) {
    if (this.checkIfPatternReady(event)) {
      return;
    }
    this.userService.getBySearchPattern(event).subscribe((data) => {
      this.businessUnitAdministratorFilterOptions = data;
    });
  }

  public saveAssignmentChanges() {}

  public deleteFromSelected(buItem: AssignBusinessUnitAdministrator) {
    const index = this.selectedBusinessUnitAdministrators.findIndex(
      (bu) => bu.id === buItem.id
    );
    if (index > -1) {
      this.selectedBusinessUnitAdministrators.splice(index, 1);
    }
  }

  public hideModal() {
    this.modalRef.hide();
    this.resetModalData();
  }

  private resetModalData() {
    this.businessUnitAdministratorFilterOptions = [];
    this.selectedBusinessUnitAdministrators = [];
  }

  private checkIfPatternReady(pattern: string): boolean {
    return (
      pattern.length >= this.configService.configData.minimumSearchStringLength
    );
  }

  private updateBusinessUnitAdministrators(buId: number): Observable<any> {
    const updatedBuIndex: number = this.businessUnitService.businessUnitAssignments.findIndex(
      (bu) => bu.id === (buId as number)
    );
    this.businessUnitService.businessUnitAssignments[
      updatedBuIndex
    ].businessUnitAdministrators = this.selectedBusinessUnitAdministrators;
    return observableOf();
  }
}
